import ServiceHero from "./hero";
import Services from "./logisticsService/service";

const Service = () => {
  return (
    <main>
      <ServiceHero />
      <Services />
    </main>
  );
};

export default Service;
